import clsx from 'clsx';
import { useState } from 'react';
import { InlineAutocompleteWithExternalTrigger } from '../input/InlineAutoComplete/InlineAutocompleteWithExternalTrigger';
import { LinkButton } from '../link/LinkButton';
import { PROFILE_IMAGE } from './ManageRecipients/constant';
import { Recipient } from './ManageRecipients/interface';
import styles from './Notifications.module.scss';
import ManageRecipientsDrawer from './ManageRecipients/ManageRecipientsDrawer';
import {
  getRecipientsIncludingCurrentUser,
  filterRecipientsInRecipientDropdown
} from './ManageRecipients/Utils';
import { Icon } from '../icon/Icon';
import { Button } from '../button/Button';

interface NotificationsHeaderProps {
  activeRecipient: Recipient | undefined;
  switchRecipient: (recipient: Recipient) => void;
}

export function NotificationsHeader({
  activeRecipient,
  switchRecipient
}: NotificationsHeaderProps) {
  const [openRecipientDropdown, setOpenRecipientDropdown] = useState(false);
  const [openManageRecipientDrawer, setOpenManageRecipientDrawer] = useState(false);

  const switchRecipientHandler = (recipient: Recipient) => {
    switchRecipient(recipient);
    setOpenRecipientDropdown(false);
  };
  return (
    <>
      <div className={clsx(styles.switchRecipientHeader, 'border-bottom')}>
        <div className='d-flex align-items-center'>
          <div className='text-body-2'>Pipeline Subscription & Alert Preferences for</div>

          <Button
            tag='a'
            variation='faded'
            className='ml-3'
            id='active-recipient'
            dataId='active-recipient'
            icon={activeRecipient?.channel_type === 'user' ? null : activeRecipient?.channel_type}
            iconSrc={activeRecipient?.channel_type === 'user' ? PROFILE_IMAGE : null}
            onClick={() => setOpenRecipientDropdown(true)}
          >
            <span className='text-body-2 ml-1 text-transform-none'>
              {activeRecipient?.channel_identifier}
            </span>

            <div className='flex-col ml-4'>
              <Icon name='up-arrow' style={{ marginBottom: '-7px' }} />
              <Icon name='dropdown-arrow' />
            </div>
          </Button>
          <InlineAutocompleteWithExternalTrigger
            dataId=''
            open={openRecipientDropdown}
            value={activeRecipient}
            onChange={value => switchRecipientHandler(value as Recipient)}
            dataSource={getRecipientsIncludingCurrentUser}
            getOptionKey={option => (option as Recipient).id}
            getOptionLabel={() => ''}
            isOptionEqualToValue={(option, value) =>
              (option as Recipient).id === (value as Recipient).id
            }
            target='#active-recipient'
            filterOptions={filterRecipientsInRecipientDropdown}
            close={() => setOpenRecipientDropdown(false)}
            renderOption={RecipientOption}
            textFieldProps={{ placeholder: 'Search Recipients' }}
            options={[]}
          />
        </div>

        <LinkButton
          icon='team'
          direction='left'
          onClick={() => setOpenManageRecipientDrawer(true)}
          dataId='manage-recipients'
          className='text-uppercase'
        >
          manage recipients
        </LinkButton>
      </div>

      <ManageRecipientsDrawer
        activeRecipient={activeRecipient!}
        switchRecipient={switchRecipient}
        closeDrawer={() => setOpenManageRecipientDrawer(false)}
        open={openManageRecipientDrawer}
      />
    </>
  );
}

function RecipientOption(props: object, option: unknown, state: object) {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const { channel_identifier, channel_type } = option as Recipient;
  return (
    <li {...props}>
      <div
        className={clsx(
          'd-flex w-100 pr-8 py-2 align-items-center',
          (state as { selected: boolean }).selected && 'text-primary'
        )}
      >
        {channel_type === 'user' ? (
          <img
            src={PROFILE_IMAGE}
            style={{ width: '20px' }}
            alt='user-profile-image'
            aria-hidden='true'
          />
        ) : (
          <Icon name={channel_type} size={3} />
        )}

        <span className='ml-1'>{channel_identifier}</span>

        {(state as { selected: boolean }).selected ? (
          <Icon name='checked-tick' className={styles.recipientOptionSelectIcon} />
        ) : null}
      </div>
    </li>
  );
}
